<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-introduction element-with-heading" epub:type="introduction" id="introduction" role="doc-introduction">
<div class="heading heading-with-title heading-without-image" id="introduction-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Major Characters in the Novel</h1>
</div>
</div>
</div>
</div>
<div class="text" id="introduction-text">
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left"><b>At Manned Spacecraft Center, Houston:</b></p>
<p class="alignment-block-content alignment-block-content-left">Dr. James Cavanaugh, Director of MSC (“Jim”)</p>
<p class="alignment-block-content alignment-block-content-left">Dr. Robert Hertz, Director of Flight Control (“Bob”)</p>
<p class="alignment-block-content alignment-block-content-left">Colonel Henry C. Barstow, Chief, Astronaut Office (“Hank”)</p>
<p class="alignment-block-content alignment-block-content-left">Colonel Bertrand L. Richmond, Director, Flight Crew Operations (“Bert”)</p>
<p class="alignment-block-content alignment-block-content-left">Colonel Conrad H. Trasker, Jr. (“Connie”), astronaut</p>
<p class="alignment-block-content alignment-block-content-left">Jane, his wife</p>
<p class="alignment-block-content alignment-block-content-left">Commander Alvin S. Weickert III (“Jazz”), astronaut</p>
<p class="alignment-block-content alignment-block-content-left">Clare, his wife</p>
<p class="alignment-block-content alignment-block-content-left">Dr. J.V. Halleck (“Jayvee”), astroscientist</p>
<p class="alignment-block-content alignment-block-content-left">Monetta, his wife</p>
<p class="alignment-block-content alignment-block-content-left">Dr. Petros S. Balkis (“Pete”), astroscientist</p>
<p class="alignment-block-content alignment-block-content-left">Colonel Hugo S. Gaudet (“Gaudy”), astronaut</p>
<p class="alignment-block-content alignment-block-content-left">Lieutenant Colonel Stuart Yule (“Stu”), astronaut</p>
<p class="alignment-block-content alignment-block-content-left">Yo-Shin, his wife</p>
<p class="alignment-block-content alignment-block-content-left">Dr. Emerson Wacker (“Em”), astroscientist</p>
<p class="alignment-block-content alignment-block-content-left">Other astronauts, astroscientists, and their wives</p>
<p class="alignment-block-content alignment-block-content-left">The medical staff</p>
<p class="alignment-block-content alignment-block-content-left">Members of the media</p>
</div>
</div>
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left"><b>In Washington, D.C.:</b></p>
<p class="alignment-block-content alignment-block-content-left">The President</p>
<p class="alignment-block-content alignment-block-content-left">The Vice President</p>
<p class="alignment-block-content alignment-block-content-left">Dr. William Anderson (“Andy”), Administrator, National Aeronautics and Space Administration</p>
<p class="alignment-block-content alignment-block-content-left">Senator John Able Winthrop of Massachusetts, chairman of the Senate Aeronautical and Space Sciences Committee</p>
<p class="alignment-block-content alignment-block-content-left">Representative James L. Satterthwaite of Wyoming, chairman of the House Science and Astronautics Committee</p>
<p class="alignment-block-content alignment-block-content-left">Senator Kennicut Williams of Indiana (“Kenny”), a member of the Senate committee</p>
<p class="alignment-block-content alignment-block-content-left">Representative Cullee Hamilton of California, a member of the House committee</p>
<p class="alignment-block-content alignment-block-content-left">Percy Mercy, editor of the magazine <i>View </i>(“P.C.M.”)</p>
<p class="alignment-block-content alignment-block-content-left">Academician Alexei S. Kuselevsky, principal space adviser to the Soviet Government</p>
<p class="alignment-block-content alignment-block-content-left">Marlon Holloway, assistant administrator for public affairs, NASA</p>
<p class="alignment-block-content alignment-block-content-left">Members of the media</p>
</div>
</div>
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left"><b>At Kennedy Space Center, Cape Kennedy, Florida:</b></p>
<p class="alignment-block-content alignment-block-content-left">Dr. Albrecht Freer, Director of KSC (“Al”)</p>
<p class="alignment-block-content alignment-block-content-left">Bob Ellison, chief of public affairs</p>
<p class="alignment-block-content alignment-block-content-left">Clete O’Donnell, a union leader</p>
<p class="alignment-block-content alignment-block-content-left">Members of the media</p>
</div>
</div>
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left"><b>At George C. Marshall Space Flight Center, Huntsville, Alabama:</b></p>
<p class="alignment-block-content alignment-block-content-left">Dr. Hans Sturmer, Director</p>
</div>
</div>
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left"><b>In Pasadena, California:</b></p>
<p class="alignment-block-content alignment-block-content-left">Dr. Vernon Hertz, Director of the Jet Propulsion Laboratory</p>
</div>
</div>
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left"><b>At North American Rockwell, Downey, California:</b></p>
<p class="alignment-block-content alignment-block-content-left">Jim Matthison, manager</p>
</div>
</div>
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left"><b>On the Moon:</b></p>
<p class="alignment-block-content alignment-block-content-left">The crew of Man in the Moon</p>
</div>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// majorcharactersinthenovel.vue?6ec79b7c